import React from 'react';
import {Message} from '@aperza/ui';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import { withTranslation } from 'react-i18next';

class FormHorizonalField extends React.Component {

  static propTypes = {
    t: PropTypes.any,
    controlId: PropTypes.string,
    fieldName: PropTypes.string.isRequired,
    fieldNameId: PropTypes.string,
    placeholderId: PropTypes.string,
    errorId: PropTypes.string,
    invalid: PropTypes.bool,
    readOnly: PropTypes.bool,
    value: PropTypes.any,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  };

  getValueFromElement(element) {
    let {
      controlType,
    } = this.props;

    let value = element.value?element.value:'';

    if (['checkbox', 'radio'].includes(controlType)) {
      if (!element.checked) {
        value = undefined;
      }
    }

    return value;
  }

  onBlur(e) {
    let value = this.getValueFromElement(e.target);
    if (this.props.onBlur) {
      this.props.onBlur(this.props.fieldName, value);
    }
  }

  onChange(e) {
    let value = this.getValueFromElement(e.target);

    if (this.props.onChange) {
      this.props.onChange(this.props.fieldName, value);
    }
  }

  render() {
    let {
      t,
      fieldName,
      fieldNameId,
      controlType,
      placeholderId,
      readOnly = false,
      errorId,
      invalid,
      value
    } = this.props;


    let placeholder = placeholderId?t(placeholderId):undefined;
    return (
      <div className="d-flex flex-row align-items-center aw-form-horizontal-field">
        {fieldNameId && !readOnly &&
        <div className={'aw-form-horizontal-field-label'}>
          <Message messageId={fieldNameId}/>
        </div>
        }
        <div className="d-flex flex-column">
          {readOnly &&
          <span>{value}</span>
          }
          {!readOnly &&
          <Form.Control placeholder={placeholder}
                        name={fieldName}
                        isInvalid={invalid}
                        value={value}
                        onBlur={::this.onBlur}
                        onChange={::this.onChange}
          />
          }
          {errorId && !readOnly &&
          <Form.Control.Feedback type="invalid" style={{display: 'block'}}>
            <Message messageId={errorId}/>
          </Form.Control.Feedback>
          }
        </div>
      </div>
    )
  }

}

export default withTranslation()(FormHorizonalField);
